import Reflux from "reflux";

/**
 * Triggered from the JWT-Checker to force a refresh.
 */
export const RefreshAction = Reflux.createAction();
